import { render } from "./FruitForm.vue?vue&type=template&id=598a5159"
import script from "./FruitForm.vue?vue&type=script&lang=js"
export * from "./FruitForm.vue?vue&type=script&lang=js"
script.render = render

export default script